import Query from '@/core/lib/new-architecture/query';
import Store from '@/core/lib/new-architecture/store';
import type { StoreData } from '@/core/lib/new-architecture/store/store.types';
import type { BadgeResult } from '@/core/types/badge';

export type Badge = BadgeResult & { isChecked: boolean };

export const badgeClassName = {
  weight: 'border-mandarine-500 bg-mandarine-50',
  co2: 'border-lagon-500 bg-lagon-800 text-[white]',
  event: 'border-green-500 bg-green-50',
};

const useBadges = (): StoreData<Badge[]> => {
  const { requestToken } = Store.auth.useRequest();

  const { data: badgesData, isLoading: isLoadingBadges } = Query.badges.useBadges({});
  const { data: userData, isLoading: isLoadingUserBadges } = Query.user.badges.useBadges({ token: requestToken });

  const unlockedAliases = new Set(userData?.badges?.map(({ value }) => value));

  const badges = badgesData?.badges?.map(badge => ({ ...badge, isChecked: unlockedAliases.has(badge.alias) }));

  const notFound = !badgesData && !isLoadingBadges;

  return {
    data: badges ?? [],
    isLoading: isLoadingBadges || isLoadingUserBadges,
    notFound,
  };
};

export default { useBadges };
